module.exports = __webpack_public_path__ + "img/t4-i6.411452eb.jpg";